<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="spins-ico"
  >
    <path d="M0.70062 17.6711C0.313678 17.2841 0.313678 16.6568 0.70062 16.2698L16.2699 0.700516C16.6569 0.313574 17.2842 0.313574 17.6712 0.700516L26.9739 10.0032C27.3608 10.3901 27.3608 11.0175 26.9739 11.4044L11.4045 26.9737C11.0176 27.3607 10.3902 27.3607 10.0033 26.9737L0.70062 17.6711Z" fill="#CC0022"/>
  </svg>
</template>

<script>
export default {
  name: 'SpinsIco'
}
</script>

<style lang="scss" scoped>
  .spins-ico {
    display: inline-block;
    padding: 0 6px;
  }
</style>
